

const czech = {
  title: "3D Model města Brna",
  description: "Návod",
  descriptnoURL: "https://webmaps.kambrno.cz/Navody/Brno_3D_model",
  hyperlink: "zde",
  cookies:{
acceptBtnText: "Nemám s tím problém",
rejectBtnText: "Bohužel ne",
mainText: "Chcete udělat radost našim GIS specialistům a povolit cookies jen pro měření návštěvnosti a používání této aplikace?"
  },
  layers: {
    buildings: "3D model budov",
    trees: "3D model dřevin",
  },
  errorHandle: {
    slow: {
      alert: {
        message_1: "Server odpovídá pomalu. Počkejte prosím.",
        message_2: "Načítání trvá déle než obvykle.",
      },
    },
    overloaded: {
      alert: {
        message_1: "Server je momentálně přetížený. Zkuste to prosím za chvíli znovu.",
      },
    },
    down: {
      alert: {
        message_1: "Služba je dočasně nedostupná. Počkejte chvíli a zkuste to znovu.",
      },
      page: {
        title: "Aplikace je dočasně nedostupná",
        message_1: "Omlouváme se, ale aplikace je dočasně nedostupná.",
        button: "Načíst stránku",
      },
    },
  },

  infopanel: {
    infoSection: {
      title: "Vítejte v aplikaci 3D model města Brna!",
      manual: "Podrobný návod",
      metadata: "Podrobnější metadata",
      manualURL: "https://webmaps.kambrno.cz/Navody/Brno_3D_model",
      metaDataUrl: "https://webmaps.kambrno.cz/Navody/Brno_3D_model/#metadata",
    },
    inAplication: {
      title: "V aplikaci najdete",
      buildings: "3D model města Brna – v rozlišení LOD2",
      trees: "3D model dřevin – pouze dřeviny z",
      treesHyperlinkText: "pasportu zeleně",
      treesHyperlink: "https://gis.brno.cz/mapa/mestska–zelen",
      trees_2: "děleny dle",
      treesSpecies: {
        button: "typu",
        title:
          "typ – listnatý strom, jehličnatý strom, listantý keř, jehličnatý keř",
      },
      and: "a",
      treesHight: {
        button: "výšky",
        title: "výška – pasport zeleně nebo 15 m (stromy), 5 m (keře)",
      },
      insertbuilding: "Vložení 3D dat – umožňuje vložit vlastní 3D modely",
      projects: "Projekty – správa vložených modelů s uloženým umístěním",
      projectsInfo: "projekt = model s uloženým umístěním",
    },
    technicSection: {
      title: "Technické požadavky",
      text_1:
        "Pro správný chod aplikace doporučujeme používat nejnovější verzi prohlížeče Chrome nebo Firefox (s podporou ",
      hyperlink: "WebGL",
      text_2:
        "), grafickou kartu s minimální pamětí 2 GB a dále kvalitní internetové připojení. Rychlost vykreslení webové scény je závislá na výše uvedených parametrech. Pokud se Vám model budov ve scéně nezobrazuje, zkuste prosím aplikaci otevřít v jiném internetovém prohlížeči.",
    },
    downloads: {
      title: "Ke stažení",
      paragraph_1: {
        text_1: "Dataset s 3D modelem je",
        hyperlink_1: "volně ke stažení v rozličných formátech",
        text_2:
          "Pro stažení pouze určitých lokalit ve formátu .dwg lze využít",
        hyperlink_2: "aplikaci pro stažení",
      },
      paragraph_2: {
        title: "Místa pohledů na vedutu města",
        text_1:
          "jsou dostupná ke stažení jak ve formátu",
        hyperlink_1: "zde",
        text_2: "tak ve formátu",
        hyperlink_2: "zde",
      },
    },
    controls: {
      title: "Ovládání",
      paragraph_1: "Posun mapy – levé tlačítko myši",
      paragraph_2: "Otáčení mapy – pravé tlačítko myši",
    },
    alternativcontrol: {
      title: "Alternativní ovládání (klávesnice)",
      w: "Otáčení nahoru",
      s: "Otáčení dolů",
      d: "Otáčení doprava",
      a: "Otáčení doleva",
      u: "Pohyb nahoru",
      j: "Pohyb dolů",
      left: "Pohyb doleva",
      up: "Pohyb dopředu",
      down: "Pohyb dozadu",
      right: "Pohyb doprava",
      esc: "Zrušení měření a analýzy viditelnosti",
    },
    tools: {
      title: "Nástroje",
      info: "Informace",
      search: "Vyhledávání",
      home: "Návrat do výchozího zobrazení",
      minus: "Oddálit",
      plus: "Přiblížit",
      basemaps: "Podkladové mapy",
      layers: "Seznam vrstev",
      upload: "Vložení 3D dat",
      viewanalyse: "Analýza viditelnosti",
      viewpoints: "Místa pohledu na vedutu města",
      daytime: "Denní doba",
      weather: "Počasí",
      measure: "Měření",
      compas: "Obnovit orientaci kompasu",
    },
  },
  popup: {
    PATA_VYSKA: "Budova: nejnižší výška (= pata)",
    HREBEN_VYSKA: "Budova: výška hřebene",
    ABS_VYSKA: "Budova: nejvyšší bod střechy",
    HORIZ_VYSKA: "Segment budovy: výška římsy",
    STRECHA_KOD: "Segment budovy: typ střechy",
    PATA_SEG_VYSKA: "Segment budovy: nejnižší výška (= pata)",
    abs_seg_vyska: "Segment budovy: nejvyšší bod střechy",
    ROK_POROZENI: "Budova: rok pořízení",
  },
  popupTree: {
    name: "Název",
    height: "Výška",
    heightPasport: "Výška vychází z pasportu zeleně",
    heightDefault: "Výška je orientační",
    emptyValue: "Hodnota nebyla vyplněna",
  },
  leftbar: {
    info: "Informace",
    home: "Návrat do výchozího zobrazení",
    language: {
      title: "English",
      language: "EN",
      url: "https://webmaps.kambrno.cz/3d-model_en",
    },
  },
  widgets: {
    layerlist: {
      title: "Seznam vrstev",
      descriptionsURL:
        "https://webmaps.kambrno.cz/webmaps.kambrno.cz/Navody/Brno_3D_model/docs/nastroje/#seznam-vrstev",
    },
    uploadmodel: {
      title: "Vložení 3D dat",
      descriptionsURL:
        "https://webmaps.kambrno.cz/webmaps.kambrno.cz/Navody/Brno_3D_model/docs/nastroje/#vlozeni-3d-dat",
      upload: {
        title: "Nahrání 3D dat",
        descriptionsURL:
          "https://webmaps.kambrno.cz/webmaps.kambrno.cz/Navody/Brno_3D_model/docs/nastroje/#nahrani-3d-dat",
        info: "Lze vkládat soubory jen ve formátu glb, popřípadě projekt (formát ZIP).",
        popup: {
          description:
            "Všechny vypočtené hodnoty se vztahují k referenčnímu bodu projektu.",
          lattitude: "Zeměpisná šířka",
          longtitude: "Zeměpisná délka",
          terain: "Terén – absolutní výška",
          refencpoint: "Referenční bod projektu – absolutní výška",
          hight: "Výška objektu",
          belowterrain: "Pod terénem",
          aboveterrain: "Nad terénem",
        },
        projectname: {
          title: "Zvolte název projektu",
          projecttitle: "Vložená budova",
          placeholder: "Např. Projekt 1",
          button: "Nahrát projekt",
        },
        dropfield: {
          button: "Vyhledat",
          description: "nebo přetáhněte soubor zde",
        },
        validation: {
          danger: {
            notsuportedformat: {
              title: "Nepodporovaný formát",
              message:
                "Nahrát můžete jen tyto formáty: Binary GL Transmission Format (.glb). Popřípadě dříve vygenerovaný soubor ZIP.",
            },
            filesizetolarge: {
              title: "Příliš velký soubor",
              message:
                "Vkládate příliš velký soubor. Lze vkládat model do velikosti 50 MB.",
            },
            zipnotcontainglb: {
              title: "Nekompletní soubor ZIP",
              message: "Rozbalený soubor ZIP neobsahuje potřebný soubor glb.",
            },
            notcontainjson: {
              title: "Nekompletní soubor ZIP",
              message:
                "Pokud vkládáte projekt exportovaný z ArcGIS Pro, je pro umístění potřebný soubor JSON se souřadnicemi.",
            },
            notcontainprj: {
              title: "Nekompletní soubor ZIP",
              message:
                "Pokud vkládáte projekt exportovaný z ArcGIS Pro, je pro umístění potřebný soubor prj pro určení souřadnicového systému.",
            },
            notcontainprjandjson: {
              title: "Nekompletní soubor ZIP",
              message:
                "Pokud vkládáte projekt exportovaný z ArcGIS Pro, je pro umístění potřebný soubor prj pro určení souřadnicového systému a soubor JSON  se souřadnicemi.",
            },
            invalidjson: {
              title: "Chybný JSON",
              message:
                "Pokud vkládáte projekt exportovaný z ArcGIS Pro, je pro umístění nutné mít soubor JSON  ve správném formátu.",
            },
            invalidcoordinate: {
              title: "Špatný souřadnicový systém",
              message:
                "Pokud vkládáte projekt exportovaný z ArcGIS Pro, je nutné mít data ve správném souřadnicovém systému. Podporovaný je jen EPSG: 4326 (WGS84).",
            },
            invalidcoordinateandjson: {
              title: "Špatný souřadnicový systém a chybný soubor JSON",
              message:
                "Pokud vkládáte projekt exportovaný z ArcGIS Pro, je nutné mít data ve správném souřadnicovém systému. Podporovaný je jen EPSG: 4326 (WGS84). Pro umístění modelu je nutné mít soubor JSON ve správném formátu.",
            },
            invalidcsv: {
              title: "Vadný soubor CSV",
              message: "Soubor CSV nemá potřebné hodnoty.",
            },
            notContainEPSGatributs: {
              title: "Špatný formát souboru PRJ",
              message:
                "Pokud vkládáte projekt exportovaný z ArcGIS Pro, je zapotřebí, aby soubor PRJ obsahoval atribut EPSG.",
            },
            notContainEPSGatributsInvalidJSON: {
              title: "Špatný formát souboru PRJ a chybný soubor JSON",
              message:
                "Pokud vkládáte projekt exportovaný z ArcGIS Pro, je zapotřebí aby soubor PRJ obsahoval atribut EPSG. Pro umístění je nutné mít JSON ve správném formátu.",
            },
          },
          success: {
            insertbyhand: {
              title: "Model byl uspěšně nahrán.",
              message:
                "Nyní lze umístit model přejetím kurzoru do webové scény.",
            },
            inserttolayerlist: {
              title: "Projekt byl uspěšně nahrán.",
              message:
                "Model byl přidán do webové scény. Projekt lze zobrazit v sekci Projekty nástroje Vložení 3D dat.",
            },
          },
          warning: {
            ziszero: {
              title: "Nulová nadmořská výška objektu",
              message:
                "Hodnota osy Z je 0. Váš model projektu byl proto umístěn na terén.",
            },
            notupload: {
              title: "Model ani projekt nebyl do aplikace vložen",
              message: "Pro vložení jej znovu musíte nahrát.",
            },
          },
        },
      },
      sampleModel: {
        title: "Ukázkový model",
        descriptionsURL:
          "https://webmaps.kambrno.cz/webmaps.kambrno.cz/Navody/Brno_3D_model/docs/nastroje/#ukazkovy-model",
        paragraph_1: "Tento model byl vytvořen pomocí softwaru ",
        paragraph_2:
          " a slouží jen pro demonstrativní účely. Nemá žádnou souvislost se současnou anebo plánovanou zástavbou.",
        place: "Umístit",
        download: "Stáhnout",
      },
      download: {
        title: "Export do projektu",
        startInfo:
          'Pro aktivaci nástroje "Export do projektu" musíte nejdříve váš 3D model umístit do webové scény.',
        descriptionsURL:
          "https://webmaps.kambrno.cz/webmaps.kambrno.cz/Navody/Brno_3D_model/docs/nastroje/#export-do-projektu",
        description: {
          title: "Export vlastního vloženého modelu do projektu",
          paragraph_1:
            "Model se stáhne jako projekt v komprimovaném souboru ZIP. Tento soubor ZIP lze znovu nahrát do této aplikace jako projekt, čímž se nám umístí na správné souřadnice i se zadaným názvem.",
          placeholder: "Název projektu",
          info: "Stažený soubor obsahuje model ve formátu glb a soubor CSV s atributy.",
          downloadbutton: "Exportovat",
        },
      },
      projekts: {
        title: "Projekty",
        startInfo:
          "Pro zobrazení projektů musíte nejdříve nahrát projekt do mapové aplikace.",
        descriptionsURL:
          "https://webmaps.kambrno.cz/webmaps.kambrno.cz/Navody/Brno_3D_model/docs/nastroje/#projekty",
        projectInfo: "Více o projektech nalznete v",
      },
    },
    viewanalyse: {
      title: "Analýza viditelnosti",
      descriptionsURL:
        "https://webmaps.kambrno.cz/webmaps.kambrno.cz/Navody/Brno_3D_model/docs/nastroje/#analyza-viditelnosti",
    },
    viewpoints: {
      title: "Místa pohledů na vedutu",
      zomin: "Přesunutí na bod",
      descriptionsURL:
        "https://webmaps.kambrno.cz/webmaps.kambrno.cz/Navody/Brno_3D_model/docs/nastroje/#mista-pohledu-na-vedutu-mesta",
    },
    daytime: {
      title: "Denní doba",
      descriptionsURL:
        "https://webmaps.kambrno.cz/webmaps.kambrno.cz/Navody/Brno_3D_model/docs/nastroje/#denni-doba",
    },
    weather: {
      title: "Počasí",
      descriptionsURL:
        "https://webmaps.kambrno.cz/webmaps.kambrno.cz/Navody/Brno_3D_model/docs/nastroje/#pocasi",
    },
    measure: {
      title: "Měření",
      area: "Měření plochy",
      direction: "Měření vzdálenosti",
      descriptionsURL:
        "https://webmaps.kambrno.cz/webmaps.kambrno.cz/Navody/Brno_3D_model/docs/nastroje/#mereni",
    },
  },
  basemaps: {
    buttons: {
      plus: "Přiblížit",
      minus: "Oddálit",
      basemaps: "Podkladové mapy",
    },
    maps: {
      ortophoto: "Ortofoto (Brno)",
      topo: "Topografická",
      dark: "Šedivá",
    },
  },
};

export default czech;
